import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $whyBlockTitle1: String,
    $whyBlockTitle1_en: String,
    $whyBlockTitle1_fr: String,
    $whyBlockTitle1_it: String,
    $whyBlockTitle1_pt: String,
    $whyBlockContent1: String,
    $whyBlockContent1_en: String,
    $whyBlockContent1_fr: String,
    $whyBlockContent1_it: String,
    $whyBlockContent1_pt: String,
    $whyBlockTitle2: String,
    $whyBlockTitle2_en: String,
    $whyBlockTitle2_fr: String,
    $whyBlockTitle2_it: String,
    $whyBlockTitle2_pt: String,
    $whyBlockContent2: String,
    $whyBlockContent2_en: String,
    $whyBlockContent2_fr: String,
    $whyBlockContent2_it: String,
    $whyBlockContent2_pt: String,
    $whyBlockImage1: String,
    $whyBlockImage2: String
) {
  updateWhyHostPage (
    whyBlockTitle1: $whyBlockTitle1,
    whyBlockTitle1_en: $whyBlockTitle1_en,
    whyBlockTitle1_fr: $whyBlockTitle1_fr,
    whyBlockTitle1_it: $whyBlockTitle1_it,
    whyBlockTitle1_pt: $whyBlockTitle1_pt,
    whyBlockContent1: $whyBlockContent1,
    whyBlockContent1_en: $whyBlockContent1_en,
    whyBlockContent1_fr: $whyBlockContent1_fr,
    whyBlockContent1_it: $whyBlockContent1_it,
    whyBlockContent1_pt: $whyBlockContent1_pt,
    whyBlockTitle2: $whyBlockTitle2,
    whyBlockTitle2_en: $whyBlockTitle2_en,
    whyBlockTitle2_fr: $whyBlockTitle2_fr,
    whyBlockTitle2_it: $whyBlockTitle2_it,
    whyBlockTitle2_pt: $whyBlockTitle2_pt,
    whyBlockContent2: $whyBlockContent2,
    whyBlockContent2_en: $whyBlockContent2_en,
    whyBlockContent2_fr: $whyBlockContent2_fr,
    whyBlockContent2_it: $whyBlockContent2_it,
    whyBlockContent2_pt: $whyBlockContent2_pt,
    whyBlockImage1: $whyBlockImage1,
    whyBlockImage2: $whyBlockImage2
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
